import React, { FC, ReactNode } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Breadcrumb, Button, Tooltip } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

import s from './PageHeader.module.scss';
import Types from '../../../../types/types';
const { applicationTooltipMessage, testApplicationTooltipMessage } = Types;
interface IPageHeader {
  breadcrumb?: Array<{ title: string | ReactNode }>;
  goBack?: () => void;
  title: string;
  width?: number | string;
  height?: number | string;
  btns?: boolean;
  checkedDoShowcase?: boolean;
  checkedApplication?: boolean;
  handleSendEmail?: (key: string) => void;
}

export const PageHeader: FC<IPageHeader> = ({
  breadcrumb,
  goBack,
  handleSendEmail,
  title,
  width,
  height,
  btns,
  checkedDoShowcase,
  checkedApplication,
}) => {
  return (
    <div className={s.PageHeader} style={{ width: width, height: height }}>
      <div className={s.links}>
        {breadcrumb.length ? <Breadcrumb items={breadcrumb} /> : ''}

        <div className={s.titleWrapper}>
          {breadcrumb.length ? (
            <Button onClick={goBack} icon={<ArrowLeftOutlined />} type={'link'}></Button>
          ) : (
            ''
          )}
          <div className={s.title}>{title}</div>
        </div>
      </div>
      {btns ? (
        <div style={{ display: 'flex' }} className={s.btnsWrapper}>
          <Tooltip title={checkedDoShowcase ? testApplicationTooltipMessage : ''}>
            <Button
              disabled={checkedDoShowcase}
              className={s.createBtn}
              onClick={() => handleSendEmail('doShowcase')}
            >
              Сделать тестовую витрину
            </Button>
          </Tooltip>
          <Tooltip title={checkedApplication ? applicationTooltipMessage : ''}>
            <Button
              disabled={checkedApplication}
              type={'primary'}
              onClick={() => handleSendEmail('application')}
            >
              Заявка на создание витрины
            </Button>
          </Tooltip>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};
